import React, { useContext, useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Accordiantb from "./Pvinaccordian";
import { FilterContext } from "../../context/Filter";

const Accordianpvin = ({ data = [] }) => {
  const [open, setOpen] = useState(false);
  // const { open, setOpen } = useContext(FilterContext)


  return (
    <div className="w-[1200px] border rounded-lg shadow-sm overflow-hidden">
      {/* Accordion Header */}
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-2 text-white text-lg font-semibold bg-[#1467B3]"
      >
        {/* Blinking text only when closed */}
        <div className={`flex-1 text-center`}>

          FleetEdge Details                </div>

        {/* Blinking arrow only when closed */}
        <div className={`ml-auto ${!open ? "blink" : ""}`}>
          {open ? <IoIosArrowUp size={28} /> : <IoIosArrowDown size={28} />}
        </div>
      </button>

      <style jsx>{`
        @keyframes blink-animation {
          0%,
          50%,
          100% {
            opacity: 1;
          }
          25%,
          75% {
            opacity: 0;
          }
        }
        .blink {
          animation: blink-animation 5s infinite;
        }
      `}</style>

      {/* Accordion Content */}
      {open && (
        <div className={`p-2 h-54 justify-center justify-items-centervc bg-white text-black text-sm`} >
          <Accordiantb data={data} />                </div>
      )
      }
    </div >
  );
};

export default Accordianpvin;
